import RequestService from "./RequestService";

const REDIRECT_URL = "https://monbureaudetudes.com";
const REDIRECT_DELAY_MS = 5000;

/**
 * Redirige vers monbureaudetudes.com après un délai.
 */
export const redirectAfterDelay = () => {
	setTimeout(() => {
		window.location.replace(REDIRECT_URL);
	}, REDIRECT_DELAY_MS);
};

/**
 * Cas 1 : Archive le devis avec raison "Projet en pause".
 * @param {string|number} id - Id du devis (quote)
 * @param {string} token - Token de l'utilisateur
 * @returns {Promise<{ request: { status: number } }>}
 */
export const archiveWithProjetEnPause = async (id, token) => {
	return await RequestService.requestCallbackCommercial(id, {
		status: "archived",
		reason: "Projet en pause",
		token,
	});
};

/**
 * Cas 2 : Notifier le commercial pour rappeler le client.
 * @param {string|number} id - Id projet ou devis (à préciser quand la route sera connue)
 * @param {string} token - Token de l'utilisateur
 * @returns {Promise<{ request: { status: number } }>}
 */
export const requestCallbackCommercial = async (id, token) => {
	return await RequestService.requestCallbackCommercial(id, {
		status: "callback",
		token
	});
};

/**
 * Cas 3 : Archive le devis avec la raison choisie par l'utilisateur.
 * @param {string|number} id - Id du devis (quote)
 * @param {string} reason - Code ou texte de la raison
 * @param {string} token - Token de l'utilisateur
 * @returns {Promise<{ request: { status: number } }>}
 */
export const archiveWithReason = async (id, reason, token) => {
	return await RequestService.requestCallbackCommercial(id, {
		status: "archived",
		reason,
		token,
	});
};

export default {
	redirectAfterDelay,
	archiveWithProjetEnPause,
	requestCallbackCommercial,
	archiveWithReason,
	REDIRECT_URL,
	REDIRECT_DELAY_MS,
};
